module.exports = __webpack_public_path__ + "static/fonts/Mont-Bold.181bbbb.woff2";